import React from "react";

export const JoinUsBannerImage = ({blog}) => {
    return (
        <div className={'hide-for-small-only'}>
            <div className={'blog-banner hide'}>
                <div className="translucent-dark-overlay" style={{height: 'auto'}}>
                </div>

            </div>
        </div>

    )
};

export default JoinUsBannerImage;
